export default __webpack_public_path__ + "static/media/DownloadImage.beb2d3bf.svg";